import { THighScore } from "../data/highScore";
import Navbar from "./HomePage/Navbar";
import "./HighScores.css";

export default function HighScores() {
    const highScores: THighScore[] = JSON.parse(localStorage.getItem("highScores") || "[]");

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB", { // TODO: have used en-GB, but, should we use en-US as the Wild West is in the US?
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    return (
        <div className="home-container">
            <Navbar />
            <h1>High Scores</h1>
            <table className="high-scores-table">
                <thead>
                    <tr>
                        <th>Character</th>
                        <th>Score</th>
                        <th>Date Played</th>
                        <th>Died</th>
                        <th>How Game Ended</th>
                    </tr>
                </thead>
                <tbody>
                    {highScores.map((highScore, index) => (
                        <tr key={index}>
                            <td>{highScore.character}</td>
                            <td>{highScore.score}</td>
                            <td>{formatDate(highScore.datePlayed)}</td>
                            <td>{highScore.gameDate}</td>
                            <td>{highScore.howGameEnded}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}